"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var range = function range(start, end) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var results = [];

  for (var value = start; value < end; value += step) {
    results.push(value);
  }

  return results;
};

var _default = range;
exports["default"] = _default;